import { render, staticRenderFns } from "./CvTemplate.vue?vue&type=template&id=71e79bc1&"
import script from "./CvTemplate.vue?vue&type=script&lang=js&"
export * from "./CvTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports